import Actions from '@/Components/Storemanager/Column/Actions';
import Category from '@/Components/Storemanager/Column/Category';
import Field from '@/Components/Storemanager/Column/Field';
import Title from '@/Components/Storemanager/Column/Title';
import FieldCategory from '@/Models/FieldCategory';

export default {
    functional: true,
    props: {
        rows: {
            type: Array,
            required: true,
        },
        column: {
            type: Object,
            required: true,
        },
        actions: {
            type: Object,
            required: true,
        },
        hasActions: {
            type: Boolean,
            required: true,
        },
        isImportModal: {
            type: Boolean,
            default: false,
            required: false
        },

        deleteModalTitle: String,
        deleteModalContent: String,
        tabindex: {
            type: Number,
            default: 0,
        },
    },

    scopedSlots: {
        actions: null,
    },

    render(createElement, context) {
        let elements = [];

        // Title
        const title = createElement(Title, {
            props: {
                column: context.props.column,
            },
            class: ['border-b', context.data.class],
        }, []);

        elements.push(title);

        // Actions
        if (context.props.hasActions) {
            elements.push(
                createElement(Actions, {
                    props: {
                        column: context.props.column,
                        actions: context.props.actions,
                        deleteModalTitle: context.props.deleteModalTitle,
                        deleteModalContent: context.props.deleteModalContent,
                        tabindex: context.props.tabindex,
                    },
                    scopedSlots: {
                        actions: context.scopedSlots.actions,
                    },
                    class: [{'border-b': context.props.rows.length > 0}, context.data.class],
                }),
            );
        }

        // Field/Category Rows
        context.props.rows.forEach((row, index) => {
            const lastRow = index === context.props.rows.length - 1;

            if (row instanceof FieldCategory) {
                // Category Row
                elements.push(
                    createElement(Category, {
                        props: {
                            column: context.props.column,
                            category: row,
                        },
                        class: [{'border-b': !lastRow}, context.data.class],
                    }),
                );

                row.filteredFields.forEach((field, i) => {
                    const lastField = i === row.filteredFields.length - 1;

                    elements.push(
                        createElement(Field, {
                            props: {
                                column: context.props.column,
                                field: field,
                                isImportModal: context.props.isImportModal
                            },
                            class: [
                                {'border-b': !(lastField && lastRow), 'hidden': !row.isOpen},
                                context.data.class,
                            ],
                        }),
                    );
                });
            } else if (!row.is_admin_only || auth.user.isAdmin) {
                // Field Row
                elements.push(
                    createElement(Field, {
                        props: {
                            column: context.props.column,
                            field: row,
                            isImportModal: context.props.isImportModal
                        },
                        class: [{'border-b': !lastRow}, context.data.class],
                    }),
                );
            }
        });

        return elements;
    },
};
